export default {
  ERROR_VENDOR_CREATE: 'We experienced an error while creating a new vendor. Please try again.',
  ERROR_VENDOR_DELETE: 'An error occurred deleting the vendor. Please try again',
  ERROR_VENDOR_NOT_FOUND: 'We couldn\'t find the requested vendor. Please ensure you have entered the correct URL or ensure the vendor still exists.',
  ERROR_VENDOR_SAVE: 'We experienced an error while saving your vendor. Please try again.',
  VENDOR_DELETE_ASK: 'Are you sure you want to delete **%%**?',
  VENDOR_DELETE_CONFIRM: 'Deleting **%%**',
} as {
  [key: string]: string,
};
